var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"item-key":"id","items-per-page":5,"headers":_vm.headers,"items":_vm.data,"loading-text":"Đang Tải","no-data-text":"Không có dữ liệu"},scopedSlots:_vm._u([{key:"item.amountMoney",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.$utils.formatMoney(item.amountMoney))+"\n  ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }